import { useState } from 'react'

export default function AccountForm({ account, organizations, providerConfigs, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    Name: account?.Name || '',
    WhatsAppOrganizationId: account?.WhatsAppOrganizationId || '',
    WhatsAppProviderConfigId: account?.WhatsAppProviderConfigId || '',
  })

  const [errors, setErrors] = useState({})

  const validate = () => {
    const newErrors = {}
    if (!formData.Name.trim()) newErrors.Name = 'Name is required'
    if (!formData.WhatsAppOrganizationId) newErrors.WhatsAppOrganizationId = 'Organization is required'
    return newErrors
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = validate()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }
    onSubmit({
      ...formData,
      WhatsAppOrganizationId: Number(formData.WhatsAppOrganizationId),
      WhatsAppProviderConfigId: formData.WhatsAppProviderConfigId ? Number(formData.WhatsAppProviderConfigId) : null,
    })
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Account Name *
        </label>
        <input
          type="text"
          value={formData.Name}
          onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., Production WhatsApp Account"
        />
        {errors.Name && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.Name}</p>}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Organization *
        </label>
        <select
          value={formData.WhatsAppOrganizationId}
          onChange={(e) => setFormData({ ...formData, WhatsAppOrganizationId: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="">Select an organization</option>
          {organizations?.map((org) => (
            <option key={org.WhatsAppOrganizationId} value={org.WhatsAppOrganizationId}>
              {org.Name}
            </option>
          ))}
        </select>
        {errors.WhatsAppOrganizationId && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">{errors.WhatsAppOrganizationId}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Provider Configuration
        </label>
        <select
          value={formData.WhatsAppProviderConfigId}
          onChange={(e) => setFormData({ ...formData, WhatsAppProviderConfigId: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="">None</option>
          {providerConfigs?.map((config) => (
            <option key={config.WhatsAppProviderConfigId} value={config.WhatsAppProviderConfigId}>
              {config.Name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition disabled:opacity-50 flex items-center space-x-2"
        >
          {loading && (
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          )}
          <span>{account ? 'Update' : 'Create'} Account</span>
        </button>
      </div>
    </form>
  )
}
